import React from 'react';
import SellerGlobeApp from './SellerGlobeApp';

function App() {
  return <SellerGlobeApp />;
}

export default App;
